exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".react-grid-HeaderCell div {\n\twhite-space: normal;\n\ttext-align: center;\n\t-o-text-overflow: ellipsis;\n\t   text-overflow: ellipsis;\n\tfont-weight: bold;\n\ttext-align: center;\n}\n\n.react-grid-Cell__value div span div{\n\t-o-text-overflow: ellipsis;\n\t   text-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/stats/components/Table/Table.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/stats/components/Table/Table.css
// module chunks = 0